import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  getShowingAggregateByUserIdEffect,
  resetShowingAggregateEffect,
  setShowingsAggregateFilterEffect,
  setShowingsFiltersAppliedEffect,
  setShowingsIsArchiveEffect,
  setShowingsTabEffect,
} from 'store/effects/showingAggregate';
import { getUserId } from 'store/selectors/user';
import {
  getShowingAggregateFilterSelector,
  getShowingAggregateList,
  getShowingIsFilterSelector,
} from 'store/selectors/showingAggregate';

import { LocationService } from 'services';
import moment from 'moment';
import _ from 'lodash';
import { AppointmentFilterStatuses } from 'types';

export const useFetchShowings = () => {
  const dispatch = useDispatch();
  const { isPending } = useSelector(getShowingAggregateList);
  const userId = useSelector(getUserId);
  const { aggregateFilters } = useSelector(getShowingAggregateFilterSelector);
  const { isFiltersApplied } = useSelector(getShowingIsFilterSelector);

  const locationSrv = new LocationService();
  locationSrv.setLocation(location);
  const query = locationSrv.getQuery();

  const getStatuses = () => ({ Status: Object.values(AppointmentFilterStatuses) });

  const getShowings = (filters = {}) => {
    dispatch(
      getShowingAggregateByUserIdEffect({
        id: userId,
        filters: { ...getStatuses(), ...filters },
      }),
    );
  };

  useEffect(() => {
    if (Object.keys(query).length) {
      const filterStatus = query.teamStats ? {} : { isMyShowings: true };
      const filters = {
        Status: query.status ? query.status.split(',') : [],
        statuses: query.statuses ? query.statuses.split(',') : [],
        DueFrom: query.dueToday ? moment() : query.dueWeek ? moment().startOf('week') : undefined,
        DueTo: query.dueToday ? moment() : query.dueWeek ? moment().endOf('week') : undefined,
      };

      const showingQueryFilters = { ...filters, ...filterStatus };
      const aggregateFilters = { ...getStatuses(), ...showingQueryFilters };

      dispatch(setShowingsFiltersAppliedEffect(true));
      dispatch(setShowingsAggregateFilterEffect(aggregateFilters));

      getShowings(showingQueryFilters);
    } else getShowings();
  }, []);

  useEffect(() => {
    return () => {
      dispatch(setShowingsIsArchiveEffect(null));
      dispatch(resetShowingAggregateEffect());
      dispatch(setShowingsTabEffect(null));
    };
  }, []);

  return {
    isPending,
    isFiltersApplied,
    fetchShowingAggregate: getShowings,
    aggregateFilters: { ...getStatuses(), ...aggregateFilters },
  };
};
